var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsInstalledPackagesIcon = function SvgDsInstalledPackagesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.353 4.503Q6.86 4 5.782 4H4v5.987h1.18v-2.13h.508q.61 0 1.024-.159.415-.16.664-.436.258-.285.368-.637.11-.36.109-.755 0-.872-.5-1.367M5.18 5.04h.54q.484 0 .71.218.228.21.227.654a.93.93 0 0 1-.133.52.76.76 0 0 1-.375.293 1.6 1.6 0 0 1-.578.093h-.39z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.494 5.409H8.22l1.696 4.545-.07.226q-.072.219-.188.403a.9.9 0 0 1-.297.302.76.76 0 0 1-.414.109q-.134 0-.258-.017a4 4 0 0 1-.204-.034v.99q.11.025.25.042.15.025.344.025.407 0 .75-.16.345-.159.602-.477a2.5 2.5 0 0 0 .43-.789l1.806-5.165h-1.25l-.79 2.574q-.055.185-.102.386a5 5 0 0 0-.062.41h-.024a2 2 0 0 0-.03-.284 2 2 0 0 0-.048-.26 2 2 0 0 0-.062-.252z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.667.667a2 2 0 0 0-2 2v10.666a2 2 0 0 0 2 2h10.666a2 2 0 0 0 2-2V2.667a2 2 0 0 0-2-2zm-.667 2C2 2.298 2.299 2 2.667 2h10.666c.368 0 .667.298.667.667v10.666a.667.667 0 0 1-.667.667H2.667A.667.667 0 0 1 2 13.333z",
    clipRule: "evenodd"
  })));
};
export default SvgDsInstalledPackagesIcon;